import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import "rsuite/dist/rsuite.min.css";
import 'react-tooltip/dist/react-tooltip.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import "./index.css";
import "./style.scss";
import "./i18n";

import { ToastContainer } from "react-toastify";

import reportWebVitals from "./reportWebVitals";
import { store } from "./redux/store";
import DefaultRoutes from "./routes/routes";
import App from "./App";
import { injectStore } from "./helper/api";


injectStore(store);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.Fragment>
    <ToastContainer autoClose={1500} />
    <Provider store={store}>
      <App />
      {/* <DefaultRoutes /> */}
    </Provider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
